import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { SectionTag } from '../SectionTag';
import { ParallaxCard } from '../ParallaxCard';
import { ParallaxHero } from '../ParallaxHero';
import { RichText } from '../RichText';

function Hero({ data, children, alignItems = 'flex-start', textAlign = 'left' }) {
  const { image, title, section, parallaxHero, imageLocation } = data || {};

  return (
    <Box as='section' py={{ base: 30, md: 40 }}>
      <Box px={{ base: 30, lg: 0 }}>
        {section && section !== 'single' && (
          <Box display='flex' alignItems='center' mb={{ base: 10, md: 20 }}>
            <Box
              flex='auto'
              display={{ base: 'none', md: 'flex' }}
              alignItems='center'
              mr={5}
              ml='-10px'
            >
              <Box flex='auto' borderBottom='2px' borderStyle='dotted' />
              <svg
                width='9'
                height='15'
                viewBox='0 0 9 15'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2 13.5829L8 7.5L2 1.41707'
                  stroke='black'
                  strokeWidth='2'
                  strokeLinecap='square'
                  strokeLinejoin='round'
                />
              </svg>
            </Box>
            <Box flex='0 0 container.md' width='container.md' maxWidth='container.md' mx='auto'>
              <SectionTag title={section} />
            </Box>
            <Box flex='1' display={{ base: 'none', md: 'flex' }} />
          </Box>
        )}
        <Box maxWidth='container.md' mx='auto'>
          <Box
            mb={{ base: 20, md: 40 }}
            display='flex'
            flexDirection='column'
            alignItems={alignItems}
          >
            {parallaxHero?.richTitle ? (
              <RichText
                value={parallaxHero.richTitle}
                as='h1'
                textStyle='h1'
                mb={children ? 30 : 0}
                width='100%'
                textAlign='center'
                fontWeight={400}
              />
            ) : (
              <Text
                as='h1'
                textStyle='h1'
                fontWeight={400}
                mb={children ? 30 : 0}
                width='100%'
                textAlign={textAlign}
              >
                {title}
              </Text>
            )}
            {children}
          </Box>
        </Box>
      </Box>
      <Box display='flex' bg='zinc.100' maxHeight='700px'>
        {image && !parallaxHero && <ParallaxHero image={image} imageLocation={imageLocation} />}
        {parallaxHero && (
          <ParallaxCard images={parallaxHero.images} aspectRatio={parallaxHero.aspectRatio} />
        )}
      </Box>
    </Box>
  );
}

export default Hero;
